var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSecurity = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 59,
  height: 82,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m24.316 80.144 3.792 1.74a.87.87 0 0 0 .866 0l4.334-1.973c15.064-6.731 24.817-22.4 24.817-39.927V17.468a1.257 1.257 0 0 0-.138-.592 1.223 1.223 0 0 0-.4-.452L29.191.174a.933.933 0 0 0-1.084 0L.58 16.424c-.168.114-.305.27-.399.452a1.257 1.257 0 0 0-.139.592V40.45c0 17.177 9.537 32.846 24.274 39.695ZM2.209 18.164 28.761 2.497l27.197 15.668v21.821c0 16.597-9.212 31.338-23.515 37.722l-3.897 1.74-3.36-1.625c-13.982-6.5-22.972-21.24-22.972-37.49l-.005-22.168Z",
  fill: "#CC0100"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.533 51.358h.107l.759-.696 18.097-15.79-1.3-1.858-17.34 15.094-7.477-9.4-1.627 1.508L23.88 50.43l.653.928Z",
  fill: "#CC0100"
})));
export default SvgSecurity;